module.exports = __webpack_public_path__ + "img/35.ce2420b.webp";